import React from "react";
import Footer from "gatsby-theme-carbon/src/components/Footer";
import {
  footer,
  grid,
  logo,
} from "gatsby-theme-carbon/src/components/Footer/Footer.module.scss";
import { useSiteMetadata } from "../../../hooks/use-site-metadata";

const CustomFooter = () => {
  const { repository } = useSiteMetadata();
  const supportUrl = `https://www.merative.com/support/curam`;
  const currentYear = new Date().getFullYear();

  const Content = ({ buildTime }) => {
    return (
      <>
        <p>
          Have questions or feedback? Browse our{" "}
          <a href={supportUrl}>Product Support Resources</a>
        </p>
        <p>
          Last updated {buildTime}
          <br />
          &copy; Merative US L.P. 2021,{currentYear}
        </p>
      </>
    );
  };

  const MerativeLogo = () => (
    <svg
      className={logo}
      height="54"
      viewBox="0 0 160 54"
      width="160"
      xmlns="http://www.w3.org/2000/svg"
    >
      <linearGradient
        id="a"
        x1=".000449%"
        x2="100.004315%"
        y1="49.998022%"
        y2="49.998022%"
      >
        <stop offset="0" stop-color="#90f" />
        <stop offset="1" stop-color="#fa1e32" />
      </linearGradient>
      <g fill="none" fill-rule="nonzero">
        <path
          d="m125.19322 25.128c0-13.824-11.254237-25.029-25.138983-25.029-13.8847455 0-25.1389828 11.205-25.1389828 25.029h3.3717514c0-11.97 9.7446328-21.6765 21.7717514-21.6765 12.022599 0 21.771751 9.702 21.771751 21.6765z"
          fill="url(#a)"
        />
        <path
          d="m27.8101695 41.616v11.565h-3.2723164v-11.7c0-2.4255-1.9751412-4.392-4.4112994-4.392-2.3231639 0-4.2305085 1.791-4.3977401 4.0635v12.033h-3.240678v-12.033c-.1717514-2.2725-2.0745763-4.0635-4.39774012-4.0635-2.43615819 0-4.41129943 1.9665-4.41129943 4.392v11.7h-3.27231639v-11.565c0-4.2165 3.43502825-7.6365 7.6700565-7.6365 2.44971754 0 4.62824854 1.143 6.03389834 2.925 1.4056497-1.782 3.5841808-2.925 6.0338983-2.925 4.2305084.0045 7.6655367 3.42 7.6655367 7.6365zm35.900565-7.2450397c-4.2350283-.0134603-7.6700565 3.4200397-7.6700565 7.6365397v11.1735h3.2723164v-11.2185c0-2.4255 2.0338983-4.3515 4.5830508-4.419 1.2384181-.036 2.6033898.0585 2.6033898.0585l.180791-3.132s-1.0169492-.09-2.9694915-.0990397zm-14.9242938 2.5110397c1.740113 1.935 2.6124294 4.2615 2.6124294 6.9795 0 .4725-.0361582.963-.1129944 1.458h-15.7514124c.3254237 1.674 1.0983051 2.97 2.3141243 3.8925s2.7118644 1.386 4.4926553 1.386c2.481356 0 4.2847458-.909 5.4146893-2.7315l2.779661 1.5705c-1.8305085 2.8215-4.5875706 4.23-8.2711864 4.23-2.9830509 0-5.4056497-.927-7.2723164-2.79-1.8666667-1.8585-2.8022599-4.212-2.8022599-7.056 0-2.8215.9129944-5.166 2.7435028-7.038 1.8305085-1.872 4.1988701-2.808 7.1050848-2.808 2.7570621.009 5.0079096.9765 6.7480226 2.907zm-.6960452 5.598c-.2757062-1.773-.9762712-3.1185-2.1062147-4.041s-2.4451977-1.386-3.9457627-1.386c-1.7536723 0-3.2090396.495-4.3615819 1.4805-1.1525424.9855-1.8666667 2.304-2.1423729 3.9465zm38.2915254-4.869h6.4271186v15.57h3.2723164v-15.57h6.3909601v-3.1455h-16.0903951zm20.5830511 15.57h3.272316v-18.711h-3.272316zm46.725423-7.857h-15.751412c.325424 1.674 1.093785 2.97 2.314124 3.8925 1.21582.9225 2.711865 1.386 4.492656 1.386 2.481356 0 4.284745-.909 5.414689-2.7315l2.779661 1.5705c-1.830508 2.8215-4.587571 4.23-8.271186 4.23-2.983051 0-5.40565-.927-7.272317-2.79-1.866666-1.8585-2.80226-4.212-2.80226-7.056 0-2.8215.912995-5.166 2.743503-7.038 1.830509-1.872 4.19887-2.808 7.105085-2.808 2.757062 0 5.00339.9675 6.748022 2.9025 1.740113 1.935 2.61243 4.2615 2.61243 6.9795 0 .477-.036158.963-.112995 1.4625zm-3.19548-2.844c-.275706-1.773-.976271-3.1185-2.106214-4.041-1.125424-.9225-2.445198-1.386-3.945763-1.386-1.753672 0-3.20904.495-4.361582 1.4805s-1.866667 2.304-2.142373 3.9465zm-83.4169489 10.701h3.5344633l5.9028248-15.192 5.9028249 15.192h3.5344633s-6.7118644-16.74-7.0915255-17.6535c-.379661-.909-1.2881355-1.548-2.3412429-1.548-1.0531073 0-1.9751412.6345-2.3412429 1.548s-7.100565 17.6535-7.100565 17.6535zm54.1423729-1.062c.366102.9135 1.288136 1.548 2.341243 1.548s1.966102-.6345 2.341243-1.548c.379661-.909 7.091525-17.6535 7.091525-17.6535h-3.534463l-5.902825 15.192-5.902825-15.192h-3.534463c.00452.0045 6.734463 16.7445 7.100565 17.6535z"
          fill="#fff"
        />
      </g>
    </svg>
  );

  const links = {
    firstCol: [],
    secondCol: [],
  };

  return <Footer links={links} Content={Content} Logo={MerativeLogo} />;
};

export default CustomFooter;
